export default __webpack_public_path__ + "static/media/up-solid.16be8917.svg";